import styled from 'styled-components';

export const StyledFooter = styled.footer`
  margin-top: auto;
  width: 100%;
  padding: 0 20px;
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
`;

export const FooterTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 40px 0;
  gap: 40px;
  flex-wrap: wrap;
`;

export const LogoColumn = styled.div`
  flex: 0 0 auto;
`;

export const InfoColumns = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.space7};
  flex-wrap: wrap;
`;

export const InfoColumn = styled.div`
  min-width: 140px;
`;

export const ColumnTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.body3.desktop.fontSize};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  margin: 0 0 ${({ theme }) => theme.spaces.space3};
  color: ${({ theme }) => theme.defaultColors.black};
`;

export const InfoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: ${({ theme }) => theme.typography.body3.desktop.fontSize};
  line-height: 1.8;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};

  a {
    color: ${({ theme }) => theme.defaultColors.fontSecondary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spaces.space4} 0;
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  font-size: ${({ theme }) => theme.typography.body3.desktop.fontSize};
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const PoweredBy = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LanguageLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LogoImage = styled.div`
  max-width: 160px;

  img {
    max-height: 60px;
    width: auto;
  }
`;

export const FallbackName = styled.span`
  font-family: ${({ theme }) => theme.headerFont}, serif;
  font-size: ${({ theme }) => theme.typography.title4.mobile.fontSize};
`;
